import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Text } from '@fly/core';
import { closeDialog, useAppDispatch } from '@fly/store';
import { Checkbox } from '@radix-ui/themes';

export const SKIP_CLEAR_CHAT_DIALOG_KEY = 'fly-chat-skip-clear-confirmation';

export const ClearChatConfirmation: React.FC<{ onConfirm: () => void }> = ({
  onConfirm,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [dontAskAgain, setDontAskAgain] = useState(false);

  return (
    <div data-testid='chat-erase-dialog' className='!mt-[-20px]'>
      <Text
        data-testid='chat-erase-dialog-title'
        size='2'
        color='neutral'
        className='text-(--text-color)'
      >
        {t('app.dashboard.chat.clear_confirmation.description', {
          defaultValue:
            "The chat will be deleted immediately. You can't undo this action.",
        })}
      </Text>
      <div className='mt-fly-4 flex flex-row items-center justify-end gap-fly-3'>
        <Text
          as='label'
          size='2'
          color='neutral'
          className='font-semibold flex flex-1 cursor-pointer'
        >
          <Checkbox
            data-testid='chat-erase-dialog-dont-ask'
            checked={dontAskAgain}
            onCheckedChange={() => setDontAskAgain((prev) => !prev)}
            className='mr-fly-3'
            color='indigo'
          />
          {t('app.dashboard.chat.clear_confirmation.dont_ask_again', {
            defaultValue: "Don't ask me again",
          })}
        </Text>
        <Button
          data-testid='chat-erase-dialog-cancel'
          size='2'
          variant='soft'
          color='neutral'
          onClick={() => dispatch(closeDialog())}
        >
          {t('app.dashboard.chat.clear_confirmation.cancel', {
            defaultValue: 'Cancel',
          })}
        </Button>
        <Button
          data-testid='chat-erase-dialog-delete'
          size='2'
          variant='solid'
          color='error'
          onClick={() => {
            if (dontAskAgain) {
              localStorage.setItem(SKIP_CLEAR_CHAT_DIALOG_KEY, 'true');
            }
            dispatch(closeDialog());
            onConfirm();
          }}
        >
          {t('app.common.actions.clear', {
            defaultValue: 'Clear',
          })}
        </Button>
      </div>
    </div>
  );
};
